import { Controller } from "stimulus";

// Simple controller to manage toggling based on an input value
//
// - Add the toggle-by-input controller on top (for ex on a form)
// - Inputs need the 'toggleChanged' action.
// - Optionally it can be givven an 'input' target attribute to update the view when connecting
// - Contents that need to be toggled to need the 'toggleContent' data target and the
//   toggle_value data attribute with a value the corresponding input can produce
//   so it can be toggled to.
//

export default class extends Controller {
  static targets = [ "toggleContent", "input" ];

  toggle(values) {
    this.toggleContentTargets.forEach(content => {
      if (values.includes(content.dataset.toggleValue)) {
        content.classList.remove("u-hidden");
      } else {
        content.classList.add("u-hidden");
      }
    });
  }

  inputChanged(evt) {
    this.toggle([evt.target.value]);
  }

  connect() {
    this.toggle(this.inputTargets.map(input => input.value));
  }
}
